<template>
    <div class="videoPlayer">
      <!-- 视频播放器容器 -->
      <video id="hlsElement" width="100%" height="100%" controls muted>
        <source :src="src" type="application/vnd.apple.mpegurl">
      </video>
    </div>
  </template>
  
  <script>
  
  export default {
    name: "HLSPlayer",
    data() {
      return {
        flvPlayer: null,
        videoElement: null,
        loaded: !1,
        playing: !1,
        src:""
      };
    },
    created() {
      //添加自定义事件，启动播放，停止播放
      window.startVideoPlay = this.startVideoPlay;
      window.stopVideoPlay = this.stopVideoPlay;
    },
    methods: {
      stopVideoPlay() {
        // this.flvPlayer &&
        //   (this.unload(),
        //   (this.videoElement = null),
        //   this.flvPlayer.detachMediaElement(),
        //   this.flvPlayer.destroy(),
        //   (this.flvPlayer = null));
      },
      unload() {
        // (this.loaded = !1),
        //   this.flvPlayer.pause(),
        //   this.flvPlayer.unload(),
        //   (this.playing = !1);
      },
      startVideoPlay(url) {
        this.src=url;
          // 获取视频元素
        //   this.videoElement = document.getElementById("videoElement");
          
        
      },
    },
    mounted() {
  
      this.startVideoPlay('https://www.kingwings.cn:7205/live/00140401000001/hls.m3u8');
    },
  };
  </script>
  
  <style scoped>
  .videoPlayer {
    overflow: hidden;
    clear: both;
    width: 100%;
    height: calc(100% - 0px);
    position: relative;
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
  }
  
  .videoPlayer > video {
    position: relative;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    -o-object-fit: fill;
    object-fit: fill;
  }
  </style>
  